export function devConsoleLog(...messages: any[]) {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  console.log(...messages);
}
